import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useState } from 'react';

import ProgressWizard from 'components/field/ProgressWizard';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalTitle } from 'components/global/styled/Modal.styled';

import useModalRouter from 'hooks/useModalRouter';

import { faCheck, faCreditCard } from '@fortawesome/pro-solid-svg-icons';

import ChangePaymentMethodCompletedModal from './ChangePaymentMethodCompletedModal';
import SelectPaymentMethodModal from './SelectPaymentMethodModal';

/**
 * @author @muhammedburakak
 */

export const ChangePaymentMethodModal = NiceModal.create(
	({ modalName, subscriptionCardID, cancelDowngradeRequest }) => {
		const { closeModal } = useModalRouter();
		const modal = useModal();
		const [selectedIndex, setSelectedIndex] = useState(0);
		const [cardLastFour, setCardLastFour] = useState('');
		const [changeCardStatus, setChangeCardStatus] = useState(false);

		const nextStep = () => {
			setSelectedIndex(selectedIndex + 1);
		};

		const prevStep = () => {
			setSelectedIndex(selectedIndex - 1);
		};

		const handleCloseModal = () => {
			if (modalName) {
				closeModal();
			} else {
				modal.resolve();
				modal.remove();
			}
		};

		const stages = [
			{ name: 'selectPaymentMethod', icon: faCreditCard },
			{ name: 'chargeAccount.complated', icon: faCheck, success: true }
		];

		const wizardArr = [
			<SelectPaymentMethodModal
				key="1"
				nextStep={nextStep}
				subscriptionCardID={subscriptionCardID}
				cancelDowngradeRequest={cancelDowngradeRequest}
				setCardLastFour={setCardLastFour}
				setChangeCardStatus={setChangeCardStatus}
			/>,

			<ChangePaymentMethodCompletedModal
				key="2"
				closeModal={handleCloseModal}
				prevStep={prevStep}
				cardLastFour={cardLastFour}
				changeCardStatus={changeCardStatus}
				cancelDowngradeRequest={cancelDowngradeRequest}
			/>
		];

		return (
			<Modal name={modalName} maxWidth="medium" fullwidth className="modal-changePaymentMethod">
				<ModalTitle>
					<Typography variant="p1">
						{cancelDowngradeRequest ? 'selectPaymentCard' : 'changePaymentMethod'}
					</Typography>
				</ModalTitle>

				<ProgressWizard
					stages={stages}
					index={selectedIndex}
					setIndex={setSelectedIndex}
					clickable={false}
					gutterBottom
				/>

				{wizardArr[selectedIndex]}
			</Modal>
		);
	}
);
